import { Acl } from "../security/types";

export interface User {
    id: string,
    name: string,
    email: string
    editorProfileId: string,
    roles: Array<string>,
    userGroupIds: Array<string>
}

export interface UserDetailsDto {
    id: string,
    firstName: string,
    lastName: string,
    email: string
    password: string
    repeatPassword: string
    roles: Array<string>,
    editorProfileId: string,
    sendPasswordChangeEmail: boolean,
    acl: Acl[],
    jobTitle: string,
    cultureCode: string,
    timeZone: string,
    userGroupIds: string[];
}

export interface UserDetailsModel {
    firstName: string,
    lastName: string,
    email: string,
    password: string
    repeatPassword: string
    sendPasswordChangeEmail: boolean,
    jobTitle: string,
    cultureCode: string,
    timeZone: string,
    editorProfileId: string;
    roles: string[];
}
export interface SelectOption {
    text: string,
    value: string
}

export interface UserGroup {
    id: string,
    name: string,
    description: string,
    azureAdGroupId: string,
    acl: Acl[],
    userIds: string[]
}

export interface UserGroupUser {
    name: string,
    userId: string,
    email: string,
    roles: string[]
}

export interface UserProfile {
    firstName: string
    lastName: string
    id: string
    email: string
    currentPassword: string
    password: string
    repeatNewPassword: string
    jobTitle: string
    newsletter: boolean
    cultureCode: string
    phoneNumber: string
    timezoneId: string
    timezoneName: string
}

export interface CopyUser {
    firstName: string
    lastName: string
    email: string
    userToCopyId: string
    jobTitle: string
}

export interface GenerateUserGroup {
    name: string
    description: string
    userToCopyId: string
}
export enum ExportColumnTitles {
    FullName = "Full name",
    Email = "Email",
    Role = "Role",
    CreationDate = "Creation date",
    LastLogin = "Last login",
    autoDelete = "Days to auto-delete",
    UserGroups = "User Groups",
    Channels = "Channels",
    FolderAccess = "Folder access",
    Solutions = "Solutions",
    Templates = "Templates"
}

// Cultures
export const Cultures = [
    {
        text: "english",
        code: "en"
    },
    {
        text: "danish",
        code: "da"
    },
    {
        text: "swedish",
        code: "se"
    }
];
